<!-- class="m-[5px]" -->
<div #container_wrapper id="container_wrapper">
  <mat-accordion style="padding: 0px">
    <!-- Expansion Panel for Stage 1 -->
    <mat-expansion-panel
      (opened)="onStageOpen(1)"
      [(expanded)]="Stage1OpenState"
      class="custom-panel-header"
      hideToggle
    >
      <mat-expansion-panel-header
        [ngStyle]="{
          background: Stage1OpenState
            ? 'var(--stage-tabs-gradient, linear-gradient(90deg, #aad4f5 0%, #eff8ff 100%))'
            : '#EFF8FF',
          'border-bottom': '2px solid #aad4f5',
          'border-top': '2px solid #aad4f5'
        }"
      >
        <mat-panel-title
          class="custom-panel-title"
          [ngStyle]="{ color: Stage1OpenState ? '#203D54' : '#868e96' }"
        >
          <mat-icon class="arrow-icon">
            {{ Stage1OpenState ? "expand_more" : "chevron_right" }}
          </mat-icon>
          Project Brief
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container *ngIf="Stage1OpenState">
        <ng-container *ngTemplateOutlet="Stage1Components"></ng-container>
      </ng-container>
    </mat-expansion-panel>

    <mat-expansion-panel
      class="custom-panel-header"
      (opened)="onStageOpen(2)"
      [hidden]="hideStage2viewmode"
      [expanded]="Stage2OpenState"
      [disabled]="false"
      hideToggle
    >
      <mat-expansion-panel-header
        [ngStyle]="{
          background: Stage2OpenState
            ? 'var(--stage-tabs-gradient, linear-gradient(90deg, #aad4f5 0%, #eff8ff 100%))'
            : '#EFF8FF',
          'border-bottom': '2px solid #aad4f5',
          'border-top': '2px solid #aad4f5'
        }"
      >
        <mat-panel-title
          class="custom-panel-title"
          style="color: #868e96"
          [ngStyle]="{ color: Stage2OpenState ? '#203D54' : '#868e96' }"
        >
          <mat-icon class="arrow-icon">
            {{ Stage2OpenState ? "expand_more" : "chevron_right" }}
          </mat-icon>
          Project Plan
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container>
        <ng-container *ngTemplateOutlet="ProjectPlanComponents"></ng-container>
      </ng-container>
    </mat-expansion-panel>

    <mat-expansion-panel
      class="custom-panel-header"
      (opened)="onStageOpen(3)"
      [hidden]="hideStage3viewmode"
      [expanded]="Stage3OpenState"
      [disabled]="false"
      hideToggle
    >
      <mat-expansion-panel-header
        [ngStyle]="{
          background: Stage3OpenState
            ? 'var(--stage-tabs-gradient, linear-gradient(90deg, #aad4f5 0%, #eff8ff 100%))'
            : '#EFF8FF',
          'border-bottom': '2px solid #aad4f5',
          'border-top': '2px solid #aad4f5'
        }"
      >
        <mat-panel-title
          class="custom-panel-title"
          [ngStyle]="{ color: Stage3OpenState ? '#203D54' : '#868e96' }"
        >
          <mat-icon class="arrow-icon">
            {{ Stage3OpenState ? "expand_more" : "chevron_right" }}
          </mat-icon>
          Project Design
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container *ngIf="Stage3OpenState">
        <ng-container *ngIf="!showStage3ViewMode">
          <ng-container *ngTemplateOutlet="Stage3Components"></ng-container>
        </ng-container>
      </ng-container>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<!-- Stage 1  Components -->
<ng-template #Stage1Components>
  <app-stage1viewmode
    (changeEdit)="handleEdit()"
    *ngIf="stages.stage1"
  ></app-stage1viewmode>

  <app-overview
    [isEdit]="isEdit"
    (changeStages)="setStagesValues($event)"
    *ngIf="!stages.stage1"
  ></app-overview>
</ng-template>

<!-- Stage 2 Components -->
<ng-template #ProjectPlanComponents>
  <div *ngIf="Stage2OpenState && stages.stage1">
    <app-plan-sections
      (changeStages)="setStagesValues($event)"
    ></app-plan-sections>
  </div>
</ng-template>

<!-- Stage 3 Components -->
<ng-template #Stage3Components>
  <div *ngIf="Stage3OpenState && stages.stage1">
    <app-designdocuments></app-designdocuments>
  </div>
</ng-template>
